export const product = ['Energizer', 'Varta']
